/**
 * @author michalstolarski
 * @since 2022-11-17
 */

import React from "react";
import { useField } from "formik";

import { TestWrapper } from "@ui/Atoms/TestWrapper";
import { RangeProps, LabelsProps, ScoreRatingRange } from "@ui/Atoms";

interface Props extends RangeProps, LabelsProps {
  testId?: string;
  className?: string;
  name: string;
  disabled?: boolean;
}

const FormikScoreRatingRange = (props: Props): React.ReactElement => {
  const [field, _, helper] = useField<number>(props.name);

  return (
    <TestWrapper testId={props.testId}>
      <div className={props.className}>
        <input type="hidden" {...field} />
        <ScoreRatingRange
          range={props.range}
          selected={field.value}
          disabled={props.disabled}
          labels={props.labels}
          onChange={helper.setValue}
        />
      </div>
    </TestWrapper>
  );
};

export { FormikScoreRatingRange };
